import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import utils from '../../../../utils/utils';
import { user } from '../../../../redux/user';
import { PERMISSION } from '../../../../constants';
import config from '../../../../config';
import viewIcon from '../../../../assets/images/docs.svg';
import downloadIcon from '../../../../assets/images/download.svg';
import { downloadAttachment, viewAttachment } from './attachmentActions';

const OnDemandStaffCredentialActions = ({ managementCompanyId, caregiverId, fileId }) => {
	const userData = useSelector(user, shallowEqual);
	const [hasError, setHasError] = useState(false);

	const hasPermission = utils.isAuthorizedExact(
		PERMISSION.WORKFORCE_SHIFTMED_VIEW,
		userData.managementCompanyPermissions[managementCompanyId]
	);

	const attachmentUrl = `${config.API_URL}/on-demand-staff/management-companies/${managementCompanyId}/professionals/${caregiverId}/attachment/${fileId}`;

	const onView = async () => {
		if (!hasPermission) {
			return;
		}
		setHasError(false);
		try {
			await viewAttachment(attachmentUrl, managementCompanyId);
		} catch {
			setHasError(true);
		}
	};

	const onDownload = async () => {
		if (!hasPermission) {
			return;
		}
		setHasError(false);
		try {
			await downloadAttachment(attachmentUrl, managementCompanyId);
		} catch {
			setHasError(true);
		}
	};

	if (!fileId) {
		return null;
	}

	const buttonClassName = classNames('btn actions', { 'download-disabled': !hasPermission });
	const viewTooltip = hasPermission ? 'View attachment' : 'You do not have permission to view this attachment';
	const downloadTooltip = hasPermission
		? 'Download attachment'
		: 'You do not have permission to download this attachment';

	return (
		<div className="credential-actions">
			<div className="credential-actions-container">
				<OverlayTrigger
					placement="bottom-end"
					trigger={['hover']}
					overlay={<Tooltip className="download-permission-tooltip">{viewTooltip}</Tooltip>}
				>
					<Button type="button" className={buttonClassName} onClick={onView}>
						<img src={viewIcon} alt="View attachment" className="credential-action-icon" />
					</Button>
				</OverlayTrigger>
				<OverlayTrigger
					placement="bottom-end"
					trigger={['hover']}
					overlay={<Tooltip className="download-permission-tooltip">{downloadTooltip}</Tooltip>}
				>
					<Button type="button" className={buttonClassName} onClick={onDownload}>
						<img src={downloadIcon} alt="Download attachment" className="credential-action-icon" />
					</Button>
				</OverlayTrigger>
			</div>
			{hasError && (
				<span className="credential-action-error" role="alert">
					Something went wrong, please try again
				</span>
			)}
		</div>
	);
};

export default OnDemandStaffCredentialActions;
